module.exports = __webpack_public_path__ + "img/flipmoney.f7cdd759.png";